import { TextInput } from '@mantine/core';
import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

import { usePortalDomain } from '@portals/framework';
import { useOpenModal } from '@portals/redux';
import { getStyledThemeColor, hexToRgba } from '@portals/utils';

import Actions from './Actions';
import { Verifying } from './verification-states';
import { useBrandingContext } from '../../../../../../branding.context';

export const DomainEdit = () => {
  const { portalConfig, updatePortalConfig } = useBrandingContext();

  const openModal = useOpenModal();
  const currentDomainName = usePortalDomain();

  return (
    <Container layout="position">
      <TextInput
        label="Your domain"
        disabled
        value={currentDomainName || portalConfig.candidate_domain}
        mb={5}
      />

      <Actions
        displayEditModeBtn={!portalConfig.candidate_domain}
        onClick={() =>
          openModal('ChangeDomain', { onUpdate: updatePortalConfig })
        }
      />

      {portalConfig.candidate_domain ? (
        <VerifyingWrapper>
          <Verifying newDomain={portalConfig.candidate_domain} />
        </VerifyingWrapper>
      ) : null}
    </Container>
  );
};

const Container = styled(motion.div)`
  margin-bottom: 15px;
`;

export const VerifyingWrapper = styled(motion.div)`
  border-radius: 8px;
  border: 1px solid ${getStyledThemeColor('gray200')};
  padding: 15px;
  margin-top: 10px;
  z-index: 1;
  transition: background-color 0.15s ease-in-out;
  background-color: ${({ theme }) => hexToRgba(theme.color.primary, 10)};
`;

export default DomainEdit;
